import { chromaKeyColor, parseChromaKeyRgb } from "@vida/surf-core";

function loadImageElement(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Caricamento immagine raster fallito"));
    img.src = src;
  });
}

/** Same-origin blob URL so canvas pixel reads are not blocked by S3 CORS. */
async function toLocalDrawableUrl(src: string): Promise<{ url: string; revoke?: () => void }> {
  if (src.startsWith("blob:") || src.startsWith("data:")) {
    return { url: src };
  }
  const res = await fetch(src, { cache: "no-store" });
  if (!res.ok) throw new Error(`Fetch raster (${res.status})`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  return { url, revoke: () => URL.revokeObjectURL(url) };
}

/** U12 — chroma-key a colore noto (palette.surface) per widget cutout / raster trasparente. */
export async function prepareRasterDisplayUrl(src: string, chromaHex: string): Promise<string> {
  const { url: drawable, revoke } = await toLocalDrawableUrl(src);
  try {
    const img = await loadImageElement(drawable);
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    if (width <= 0 || height <= 0) return src;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return src;

    ctx.drawImage(img, 0, 0);
    const imageData = ctx.getImageData(0, 0, width, height);
    const changed = chromaKeyColor(
      imageData.data,
      width,
      height,
      parseChromaKeyRgb(chromaHex),
    );
    if (!changed) return src;

    ctx.putImageData(imageData, 0, 0);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!blob) return src;
    return URL.createObjectURL(blob);
  } finally {
    revoke?.();
  }
}

/** @deprecated use prepareRasterDisplayUrl */
export async function prepareCutoutDisplayUrl(src: string, chromaHex: string): Promise<string> {
  return prepareRasterDisplayUrl(src, chromaHex);
}
